module.exports = __webpack_public_path__ + "static/media/vibino-feature-Icon-pic1.8b884c75.jpg";